import { useState } from "react";

interface MatchDateProps {
  date: string | null;
  isEditable: boolean;
  onUpdate: (newDate: string) => Promise<void>;
}

const MatchDate: React.FC<MatchDateProps> = ({
  date,
  isEditable,
  onUpdate,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [dateValue, setDateValue] = useState(date || "");

  const handleSave = async () => {
    await onUpdate(dateValue);
    setIsEditing(false);
  };

  return (
    <div className="flex items-center my-2">
      <p className="min-w-24">
        Date:{" "}
        {date
          ? new Date(date).toLocaleString("de-DE", {
              timeZone: "UTC",
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
            })
          : "tbd"}
      </p>
      {isEditable && (
        <>
          {!isEditing && (
            <button
              onClick={() => setIsEditing(true)}
              className="py-1 px-3 ml-2 rounded-xl bg-blue-500 hover:bg-blue-600"
            >
              Edit Date
            </button>
          )}
          {isEditing && (
            <div className="flex flex-wrap gap-2 items-center mt-2">
              <input
                type="datetime-local"
                value={dateValue}
                onChange={(e) => setDateValue(e.target.value)}
                className="w-60 px-3 py-2 border rounded-xl text-black"
              />
              <button
                onClick={handleSave}
                className="py-1 px-3 rounded-xl bg-green-500 hover:bg-green-600"
              >
                Save
              </button>
              <button
                onClick={() => {
                  setIsEditing(false);
                  setDateValue(date || "");
                }}
                className="py-1 px-3 rounded-xl bg-gray-500 hover:bg-gray-600"
              >
                Cancel
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default MatchDate;
